import React from 'react';
import { ContentProvider } from '../context/ContentContext';
import { DevelopmentEnginesProvider } from '../context/DevelopmentEnginesContext';
import { HeroProvider } from '../context/HeroContext';
import { ImpactProvider } from '../context/ImpactContext';
import { LegalProvider } from '../context/LegalContext';
import { LinksProvider } from '../context/LinksContext';
import { NewsProvider } from '../context/NewsContext';

const AppProviders = ({ children }) => {
  return (
    <HeroProvider>
      <ContentProvider>
        <NewsProvider>
          <LegalProvider>
            <LinksProvider>
              <ImpactProvider>
                <DevelopmentEnginesProvider>{children}</DevelopmentEnginesProvider>
              </ImpactProvider>
            </LinksProvider>
          </LegalProvider>
        </NewsProvider>
      </ContentProvider>
    </HeroProvider>
  );
};

export default AppProviders;
